export function SectionTitle({ eyebrow, title, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
      <div>
        <p className="font-mono-cx text-[10px] uppercase tracking-[0.3em] text-cyan-400 mb-2">{eyebrow}</p>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-slate-50">{title}</h1>
      </div>
      {children}
    </div>
  );
}

export function StatCard({ label, value, tone = "cyan", testId }) {
  const tones = { cyan: "text-cyan-300", red: "text-red-300", amber: "text-amber-300", green: "text-emerald-300" };
  return (
    <div className="cx-glass rounded-2xl p-5" data-testid={testId}>
      <p className="text-[11px] font-mono-cx uppercase tracking-widest text-slate-500">{label}</p>
      <p className={`font-display text-3xl font-extrabold mt-2 ${tones[tone]}`}>{value}</p>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="text-[11px] font-mono-cx uppercase tracking-widest text-slate-400">{label}</span>
      <div className="mt-1.5">{children}</div>
    </label>
  );
}

export function Empty({ text }) {
  return <div className="cx-glass rounded-2xl p-10 text-center text-sm text-slate-500">{text}</div>;
}

export const statusBadge = (s) => ({
  pending: "bg-amber-950 text-amber-300 border-amber-500/50",
  approved: "bg-emerald-950 text-emerald-300 border-emerald-500/50",
  rejected: "bg-red-950 text-red-300 border-red-500/50",
  open: "bg-amber-950 text-amber-300 border-amber-500/50",
  closed: "bg-slate-900 text-slate-400 border-slate-700",
}[s] || "bg-slate-900 text-slate-400 border-slate-700");

export const statusLabel = (s) => ({ pending: "Bekliyor", approved: "Onaylandı", rejected: "Reddedildi", open: "Açık", closed: "Kapandı" }[s] || s);
